import React, { memo, useContext } from 'react';
import GridFilterContext from '@modules/analysis/detail/subsidiaries/grid/gridFilterContext';

function FilterIcon({ filterKey, optionsLength = [] }) {
  const filters = useContext(GridFilterContext);

  const active = filters[filterKey]?.length < optionsLength;

  return (
    <span
      className={`appkiticon ${
        active ? 'active icon-filter-fill' : 'icon-filter-outline'
      }`}
    />
  );
}

export default memo(FilterIcon);
